import { makeObservable, observable, action, runInAction, toJS } from "mobx";
import "../../config";
import {
  addNewTranslations,
  getAllTranslations,
  getTranslation,
  updateTranslation,
} from "../../API/v2/api.translation";
import handleAPIError, {
  MESSAGE_CODES,
  showSuccessToast,
  showWarningToast,
} from "../../services/toast";

const showUnknownError = (error) => {
  console.error("Translation request failed", error);
  return handleAPIError(error, {
    throwError: false,
  });
};


class TranslationStore {
  translations = [];
  selectedComponent = null;
  selectedLanguage = "en";
  selectedTranslation = [];
  isEdit = false;
  addNewLoading = false;
  deleteKey = null;
  isChanges = false;

  constructor() {
    makeObservable(this, {
      translations: observable,
      selectedComponent: observable,
      selectedLanguage: observable,
      selectedTranslation: observable,
      isEdit: observable,
      addNewLoading: observable,
      deleteKey: observable,
      isChanges: observable,

      getAllTranslations: action.bound,
      _handleSelectedComponent: action.bound,
      _handleSelectedLanguage: action.bound,
      getTranslation: action.bound,
      _handleChangeValue: action.bound,
      _handleDelete: action.bound,
      addNewWords: action.bound,
      _handleSelectedTranslation: action.bound,
      updateTranslation: action.bound,
      _handleDeleteKey: action.bound
    });
  }

  _handleDeleteKey = k => runInAction(() => this.deleteKey = k)

  addNewWords = async (words) => {
    this.addNewLoading = true;
    const object = {};
    for (const word of words) {
      object[word.key] = word.value;
    }
    const response = await addNewTranslations(
      this.selectedLanguage,
      this.selectedComponent?.url,
      object
    );
    const { success, payload, error } = response;
    if (error) {
      this.addNewLoading = false;
      return showUnknownError(error);
    }
    if (success && payload) {
      this.addNewLoading = false;
      this._handleSelectedTranslation(payload.result.tran.find((t) => t.name === this.selectedLanguage)?.data);
      const existWordLen = payload.existWord.length;
  
      if (existWordLen <= 0) {
        showSuccessToast({
          apiData: response,
          scenarioCode: MESSAGE_CODES.TRANSLATION_CREATE_SUCCESS,
        });
      } else {
        showWarningToast({
          apiData: response,
          scenarioCode: MESSAGE_CODES.TRANSLATION_ALREADY_EXISTS,
        });
      }
  
      document.getElementById("addNewTranslationModalClose").click();
    }
  };
  

  _handleEditMode = () => {
    runInAction(() => {
      this.isChanges = false;
      this.isEdit = !this.isEdit;
    });
  };

  getAllTranslations = async () => {
    const { success, payload, error } = await getAllTranslations();
    if (error) return showUnknownError(error);
    if (success && payload) {
      runInAction(() => (this.translations = payload));
    }
  };

  _handleSelectedComponent = (value) => {
    runInAction(() => {
      this.selectedComponent = value;
    });
    this.getTranslation();
  };

  _handleSelectedLanguage = (value) => {
    console.log(value);
    runInAction(() => {
      this.selectedLanguage = value;
    });
    this.getTranslation();
  };

  _handleChangeValue = (type, value, key) => {
    runInAction(() => {
      this.isChanges = true;
      if (type === "key") this.selectedTranslation[key] = value;
      // else this.selectedTranslation[i].value = value;
      else this.selectedTranslation.map( (v) => {
      if( v.key == key) {
        v.value = value
      }
      })
    });
  };

  _handleDelete = () => {
    runInAction(() => {
      if(this.deleteIndex !== null){
        this.isChanges = true;
        this.selectedTranslation = this.selectedTranslation.filter(v => v.key !== this.deleteKey)

        console.log("delete>>>>", toJS(this.deleteIndex));
        
        document.getElementById("confirmDeleteTranslationClose").click()
        this.deleteKey = null
      }
    });
  };

  _handleSelectedTranslation = (object) => {
    const temp = [];
    runInAction(() => {
      Object.keys(object)?.forEach((k) => {
        temp.push({
          key: k,
          value: object[k],
        });
      });
      console.log(toJS(temp));
      const data = temp.sort((a,b) => a?.key.localeCompare(b?.key) )
      console.log(toJS(data));
      this.selectedTranslation = data;
    });
  };

  getTranslation = async () => {
    if (this.selectedComponent?.url) {
      const result = await getTranslation(
        this.selectedLanguage,
        this.selectedComponent?.url
      );
      this._handleSelectedTranslation(result);
    }
  };

  updateTranslation = async () => {
    if(this.selectedComponent){
      const object = {};
      for(const st of this.selectedTranslation){
        object[st.key] = st.value
      }
      const response = await updateTranslation(this.selectedLanguage,this.selectedComponent?.url,object);
      const {success,error,payload} = response;
      if(error) return showUnknownError(error)
      if(success && payload){
        this._handleSelectedTranslation(payload.tran.find(t => t.name === this.selectedLanguage)?.data)
        this.isEdit = false;
        showSuccessToast({
          apiData: response,
          scenarioCode: MESSAGE_CODES.TRANSLATION_UPDATE_SUCCESS,
        });
      }
    } 
  };
}

export default new TranslationStore();
